import { render } from "./section-sidebar.vue?vue&type=template&id=60b2ecce"
import script from "./section-sidebar.vue?vue&type=script&lang=js"
export * from "./section-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__